module.exports = __webpack_public_path__ + "static/media/image6.a084b18f.jpg";